import React from 'react'
import { Modal } from 'is24-corecss'
import { useTranslation } from 'react-i18next'

import { InitState } from '../../../../redux/reducers/root/initialState'
import { useAppSelector } from '../../../../app/hooks'
import { useDisableBodyScroll } from '../../hooks/useDisableBodyScroll'

export interface ModalContainerProps {
  title: string
  children: React.ReactNode
  dataTestid?: string
  onClose: () => void
}

const PreviewModalContainer: React.FC<ModalContainerProps> = ({ title, children, dataTestid, onClose }) => {
  const { t } = useTranslation()
  const { previewModalIsOpen } = useAppSelector((state: InitState) => state.previewFeature)
  useDisableBodyScroll(previewModalIsOpen)

  return (
    <Modal.Root isOpen={previewModalIsOpen} onClose={onClose}>
      <Modal.Backdrop>
        <Modal.Surface width='80%' {...(dataTestid && { 'data-testid': dataTestid })}>
          <Modal.Header>
            <Modal.TitleGroup>
              <Modal.Title>{t(title, 'Close')}</Modal.Title>
            </Modal.TitleGroup>
            <Modal.CloseButton aria-label='close' />
          </Modal.Header>
          <Modal.Body>{children}</Modal.Body>
        </Modal.Surface>
      </Modal.Backdrop>
    </Modal.Root>
  )
}

export default PreviewModalContainer
